import React from "react";

import { TitleSmall } from "Cobalt/Header";
import { ReduxTrigger, ModalBody, ModalHeader } from "Cobalt/Modal";
import { CarrierLogo } from "Common/CarrierLogo";
import DentalPlanDetails from "Common/plans/DentalPlanDetails";
import VisionPlanDetails from "Common/plans/VisionPlanDetails";

import makeBem from "Utils/makeBem";

const bem = makeBem("PlanDetailsModal");

function renderModal(plan) {
  switch (plan.type) {
    case "dental":
      return <DentalPlanDetails plan={plan} striped />;

    case "vision":
      return <VisionPlanDetails plan={plan} striped />;
  }
}

const PlanDetailsModal = ({ plan }) => (
  <ReduxTrigger name={plan.display_name}>
    <ModalHeader closeButton>
      <TitleSmall mt={0} mb={0}>
        <CarrierLogo plan={plan} maxSize={3} mr={2} />
        {plan.display_name}
      </TitleSmall>
    </ModalHeader>
    <ModalBody className={bem("body")}>{renderModal(plan)}</ModalBody>
  </ReduxTrigger>
);

export default PlanDetailsModal;
